import React, { useState } from 'react';
import { NavLink} from 'react-router-dom';
import styles from './css/professional.module.css';

import { CiClock1, CiBoxList, CiCalendar, CiLaptop } from "react-icons/ci";

import ai from '../../../assets/aiml.jpg'
import dataanalysis from '../../../assets/data-science.jpg'
import cybersecurity from '../../../assets/security.webp'


const courses = [
    {
      id: 1,
      name: 'AI & Machine Learning',
      image: ai,
      duration: '12 Months',
      details: [
        'Application-based Programming in Python', 
        'Inferential Statistical Analysis', 
        'AI Primer', 
        'AI Applications of NLP', 
        'AI and ML with Python', 
        'Applied Machine Learning using Python', 
        'Deep learning using Neural Networks', 
        'Capstone Project-Recommendation Engine and Customer Churn Prediction'
      ],
      benefits: [
        'Gain in-demand skills in AI, ML, and Deep Learning',
        'Build and deploy real-world AI models and solutions',
        'Prepare for global careers in AI engineering, data science, and automation'
      ],
      schedule: '8 Hours Per Week',
      format: 'Onsite / Online',
    },
    {
      id: 2,
      name: 'Data Science',
      image: dataanalysis,
      duration: '8 Months',
      details: [
        'Application-based Programming in Python', 
        'Data Mining with WEKA', 
        'Data Science using R Programming', 
        'Data Science with Python', 
        'Foundation of Big Data Systems with Hadoop', 
        'Advanced Data Science with Python', 
        'Visual Analytics with Tableau', 
        'Capstone Project for Data Science'
      ],
      benefits: [
        'Master data analysis, visualization, and predictive modeling',
        'Work with industry tools like Python, R, Hadoop, and Tableau',
        'Launch a career in data analytics, business intelligence, or big data engineering'
      ],
      schedule: '8 Hours Per Week',
      format: 'Onsite / Online',
    },
    {
      id: 3,
      name: 'Cybersecurity',
      image: cybersecurity,
      duration: '8 Months',
      details: [
        'Fundamentals of JavaScript', 
        'Security Architecture and Hacking', 
        'Security Programming with Python', 
        'Windows and Linux Hacking', 
        '...'
      ],
      benefits: [
        'Develop critical skills in ethical hacking, network defense, and security analysis',
        'Learn to protect systems against cyber threats and vulnerabilities',
        'Prepare for certifications and careers in cybersecurity and ethical hacking'
      ],
      schedule: '8 Hours Per Week',
      format: 'Onsite / Online',
    },
  ];
  

export default function Professional() {
  const [selectedCourse, setSelectedCourse] = useState(null);

  return (
    <section className={styles.professionalSection}>
      <h2 className={styles.title}>Professional Courses</h2>
        <p className={styles.subtitle}>Stay ahead in today’s competitive world by mastering the skills that top employers demand. Our professional courses are designed to equip you with industry-relevant knowledge, hands-on experience, and globally recognized certifications. Whether you’re starting your career, advancing in your field, or switching to a new path, our expert-led training ensures you are prepared to succeed. Invest in yourself today, build the future you deserve!</p>
      <div className={styles.cardContainer}>
        {courses.map((course, index) => (
          <div
            key={course.id}
            className={`${styles.card} ${styles.fadeIn}`}
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            <img src={course.image} alt={course.name} className={styles.courseImage} />
            <h3 className={styles.courseName}>{course.name}</h3>
            <p>Duration: {course.duration}</p>
            <button className={styles.learnMoreBtn} onClick={() => setSelectedCourse(course)}>
              Learn More
            </button>
          </div>
        ))}
      </div>

      {selectedCourse && (
        <div className={styles.modalOverlay}>
          <div className={styles.modal}>
            <h2>{selectedCourse.name}</h2>

            <p><CiClock1 className={styles.icon} /> <strong>Duration:</strong> {selectedCourse.duration}</p>

            <div className={styles.detailList}>
              <p><CiBoxList className={styles.icon} /> <strong>Full Details:</strong></p>
              <p>{selectedCourse.details.join(', ')}</p>
            </div>

            <div className={styles.detailList}>
              <p><CiBoxList className={styles.icon} /> <strong>Benefits:</strong></p>
              <ul>
                {selectedCourse.benefits.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            <p><CiCalendar className={styles.icon} /> <strong>Schedule:</strong> {selectedCourse.schedule}</p>
            <p><CiLaptop className={styles.icon} /> <strong>Format:</strong> {selectedCourse.format}</p>

            {/* <a href={selectedCourse.contactUrl} className={styles.contactBtn} target="_blank" rel="noopener noreferrer">
              Contact Us
            </a> */}
            <NavLink exact="true" to="/apply" className={styles.contactBtn}>Apply</NavLink>
            <button className={styles.closeBtn} onClick={() => setSelectedCourse(null)}>Close</button>
          </div>
        </div>
      )}
    </section>
  );
}
